import { Trophy, Users, Target, Award } from "lucide-react"
import { colors } from "../../styles/theme"
import { TournamentStats } from "./types"

interface QuickStatsProps {
  stats: TournamentStats
}

export function QuickStats({ stats }: QuickStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <div
        className="p-4 rounded-lg border"
        style={{ backgroundColor: colors.background.secondary, borderColor: colors.border.primary }}
      >
        <div className="flex items-center">
          <div className="p-2 rounded-lg" style={{ backgroundColor: colors.primary[900] }}>
            <Trophy className="h-5 w-5" style={{ color: colors.primary[400] }} />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium" style={{ color: colors.text.secondary }}>
              Active Events
            </p>
            <p className="text-lg font-semibold" style={{ color: colors.text.primary }}>
              {stats.activeEvents}
            </p>
          </div>
        </div>
      </div>
      <div
        className="p-4 rounded-lg border"
        style={{ backgroundColor: colors.background.secondary, borderColor: colors.border.primary }}
      >
        <div className="flex items-center">
          <div className="p-2 rounded-lg" style={{ backgroundColor: colors.status.success + "20" }}>
            <Users className="h-5 w-5" style={{ color: colors.status.success }} />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium" style={{ color: colors.text.secondary }}>
              Total Drivers
            </p>
            <p className="text-lg font-semibold" style={{ color: colors.text.primary }}>
              {stats.totalDrivers}
            </p>
          </div>
        </div>
      </div>
      <div
        className="p-4 rounded-lg border"
        style={{ backgroundColor: colors.background.secondary, borderColor: colors.border.primary }}
      >
        <div className="flex items-center">
          <div className="p-2 rounded-lg" style={{ backgroundColor: colors.status.warning + "20" }}>
            <Target className="h-5 w-5" style={{ color: colors.status.warning }} />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium" style={{ color: colors.text.secondary }}>
              Live Brackets
            </p>
            <p className="text-lg font-semibold" style={{ color: colors.text.primary }}>
              {stats.liveBrackets}
            </p>
          </div>
        </div>
      </div>
      <div
        className="p-4 rounded-lg border"
        style={{ backgroundColor: colors.background.secondary, borderColor: colors.border.primary }}
      >
        <div className="flex items-center">
          <div className="p-2 rounded-lg" style={{ backgroundColor: colors.status.info + "20" }}>
            <Award className="h-5 w-5" style={{ color: colors.status.info }} />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium" style={{ color: colors.text.secondary }}>
              Total Prize Pool
            </p>
            <p className="text-lg font-semibold" style={{ color: colors.text.primary }}>
              {stats.totalPrizePool}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
} 